import React from "react"
import { useDispatch } from "react-redux"
import { FaMinus, FaPlus, FaTrashAlt } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import {
  store,
  deleteOrderItem,
  updateOrderItem
} from "@redux"
import { isStockLimited } from "utils"
import { IconButton } from "components"
import classes from "./FoodOrderItemCardHeader.module.scss"

const FoodOrderItemCardHeader = props => {
  const { orderItem } = props

  const i18n = useTranslation()[1]

  const dispatch = useDispatch()

  const handleIncrease = (e) => {
    const {
      order: { items: orderItems }
    } = store.getState()

    const targetOrderItem =
      orderItems.find(oi =>
        oi.orderItemId === orderItem.orderItemId
      )

    const newQuantity =
      Number(
        Number(targetOrderItem.quantity + 1).toFixed(2)
      )

    const increasedQuantity = 1

    const limitedStock =
      isStockLimited(targetOrderItem, increasedQuantity)

    if (limitedStock) return

    dispatch(
      updateOrderItem(
        { quantity: newQuantity },
        orderItem.orderItemId
      )
    )
  }

  const handleDecrease = (e) => {
    const {
      order: { items: orderItems }
    } = store.getState()

    const targetOrderItem =
      orderItems.find(oi =>
        oi.orderItemId === orderItem.orderItemId
      )

    const newQuantity =
      Number(
        Number(targetOrderItem.quantity - 1).toFixed(2)
      )

    if (newQuantity <= 0) return

    dispatch(
      updateOrderItem(
        { quantity: newQuantity },
        orderItem.orderItemId
      )
    )
  }

  const handleDelete = () => {
    dispatch(
      deleteOrderItem(
        orderItem.orderItemId
      )
    )
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["header"]}>
      <IconButton
        size={22}
        icon={FaTrashAlt}
        color="var(--color-danger)"
        onClick={handleDelete}
      />
      <div className={classes["left"]}>
        <IconButton
          size={22}
          icon={FaMinus}
          color="white"
          onClick={handleDecrease}
          className={classes["button"]}
        />
        <IconButton
          size={22}
          icon={FaPlus}
          color="white"
          onClick={handleIncrease}
          className={clsx(classes["button-add"], isLtr && classes["button-add-ltr"])}
        />
      </div>
    </div>
  )
}

export default FoodOrderItemCardHeader